export default "__VITE_ASSET__f7395964__"